import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineBanner() {
  const online = useOnlineStatus();
  const { t } = useTranslation();

  if (online) return null;

  return (
    <div
      role="status"
      className="oche-offline-banner border-b border-[var(--color-amber)]/40 bg-[var(--color-amber)]/10 px-5 py-2 text-center text-sm text-[var(--color-amber)]"
    >
      {t('offline.banner')}
    </div>
  );
}
